// Pagination Component
// It includes the code for displaying and filtering Awards, News, Generic Grid (Berkeley Inspirations) and Global Search Results
let pageValue;
let restSuccess;
let restError;
let yearsNoData;
let yearsEmpty;
let globalKey;
let gridUid;
let gridWithUID;
let pageValueTemp;

let state = {};
let loaderWrap;
let loader;
let loaderTitle;
let listContainer;
let errorWrap;
let errorTitle;
let yearsNoDataWrap;
let yearsNoDataTitle;

let awards;
let filterWrap;
let grid;
let search;
let filterSearchWrap;

let nonNewsPaginatedComponent = document.querySelector('#list-card-component:not(.news-article-component):not(.inspiration-article-component)');
if (nonNewsPaginatedComponent) {
    awards = document.querySelector('.awards-card-component');
    filterWrap = document.querySelector('.awards-card-component--filter');

    grid = document.querySelector('.generic-grid-component');
    search = document.querySelector('.global-search--results');
    filterSearchWrap = document.querySelector('.global-search');

    if (document.querySelector('.page-number')) {
        pageValue = document.querySelector('.page-number').value;
    }
    if (document.querySelector('.rest-message--success')) {
        restSuccess = document.querySelector('.rest-message--success').value;
    }
    if (document.querySelector('.rest-message--fail')) {
        restError = document.querySelector('.rest-message--fail').value;
    }
    if (document.querySelector('.years-nodata')) {
        yearsNoData = document.querySelector('.years-nodata').value;
    }

    if (document.querySelector('.generic-grid--element')) {
        gridUid = document.querySelector('.generic-grid--element').value;
    }

    if (document.querySelector('.page-number')) {
        pageValueTemp = document.querySelector('.page-number').value;
    }

    // add tooltips to state
    state = {
        querySet: '',
        page: 1, //Current page
        rows: pageValue,
        total: 10,
        window: 5, //Items in pagination
        match: '',
        nomatch: '',
        empty: '',
        cta: '',
        matches: 0,
        keyword: '',
        buttonTooltips: {
            firstPage: 'First Page',
            lastPage: 'Last Page',
            nextPage: 'Next Page',
            page: 'Page ',
            prevPage: 'Previous Page'
        }
    };

    //Loader
    loaderWrap = document.createElement('div');
    loader = document.createElement('div');
    loaderTitle = document.createElement('div');
    listContainer = document.getElementById('list-card-component');

    loaderWrap.classList.add('loader-wrapper');
    loaderTitle.classList.add('loader-title');
    loader.classList.add('loader');
    loaderTitle.textContent = restSuccess;
    loaderWrap.appendChild(loaderTitle);
    loaderWrap.appendChild(loader);

    //Error
    errorWrap = document.createElement('div');
    errorTitle = document.createElement('div');
    errorWrap.classList.add('error-wrapper');
    errorTitle.classList.add('error-title');
    errorTitle.textContent = restError;

    errorWrap.appendChild(errorTitle);

    //Years with no data
    yearsNoDataWrap = document.createElement('div');
    yearsNoDataTitle = document.createElement('div');
    yearsNoDataWrap.classList.add('error-wrapper');
    yearsNoDataTitle.classList.add('error-title');
    yearsNoDataTitle.textContent = yearsNoData;

    yearsNoDataWrap.appendChild(yearsNoDataTitle);
}

//Pagination
function pagination(querySet, page, rows, total) {
    let trimStart = 0;
    let trimEnd = rows;

    let trimmedData = querySet.slice(trimStart, trimEnd);

    let pages = Math.ceil(total / rows);

    return {
        querySet: trimmedData,
        pages: pages,
    };
}

function pageButtons(pages) {
    let wrapper = document.getElementById('pagination-wrapper');
    wrapper.innerHTML = '';

    let maxLeft = state.page - Math.floor(state.window / 2);
    let maxRight = state.page + Math.floor(state.window / 2);

    if (maxLeft < 1) {
        maxLeft = 1;
        maxRight = state.window;
    }

    if (maxRight > pages) {
        maxLeft = pages - (state.window - 1);

        if (maxLeft < 1) {
            maxLeft = 1;
        }
        maxRight = pages;
    }

    let pageActive;
    for (let page = maxLeft; page <= maxRight; page++) {
        if (state.page === page) {
            pageActive = page;
            wrapper.innerHTML = `${wrapper.innerHTML}
            <li>
                <button type="button" class="page active" value=${page}>
                    <span class="visually-hidden">${state.buttonTooltips.page}</span> ${page}
                </button>
            </li>`;
        } else {
            wrapper.innerHTML = `${wrapper.innerHTML}
            <li>
                <button type="button" class="page" value=${page}>
                    <span class="visually-hidden">${state.buttonTooltips.page}</span> ${page}
                </button>
            </li>`;
        }
    }

    if (state.page != 1) {
        wrapper.innerHTML =
            `<li class="page-first">
                <button type="button" class="page" value='1'>
                    <span class="icon-double-chevron-left"></span>
                    <span class="visually-hidden">${state.buttonTooltips.firstPage}</span>
                </button>
            </li>
            <li class="page-prev">
                <button type="button" class="page" value='${pageActive - 1}'>
                    <span class="icon-single-chevron-left"></span>
                    <span class="visually-hidden">${state.buttonTooltips.prevPage}</span>
                </button>
            </li> 
            ${wrapper.innerHTML}`;
    } else {
        wrapper.innerHTML =
            `<li class="disabled page-first">
                <button type="button" class="page" tabindex="-1" value='1'>
                    <span class="icon-double-chevron-left"></span>
                    <span class="visually-hidden">${state.buttonTooltips.firstPage}</span>
                </button>
            </li>
            <li class="disabled page-prev">
                <button type="button" class="page" tabindex="-1" value='${pageActive - 1}'>
                    <span class="icon-single-chevron-left"></span>
                    <span class="visually-hidden">${state.buttonTooltips.prevPage}</span>
                </button>
            </li>
            ${wrapper.innerHTML}`;
    }

    if (state.page != pages) {
        wrapper.innerHTML = `${wrapper.innerHTML}
            <li class="page-next">
                <button type="button" class="page" value='${pageActive + 1}'>
                    <span class="icon-single-chevron"></span>
                    <span class="visually-hidden">${state.buttonTooltips.nextPage}</span>
                </button>
            </li>
            <li class="page-last">
                <button type="button" class="page" value='${pages}'>
                    <span class="icon-double-chevron"></span>
                    <span class="visually-hidden">${state.buttonTooltips.lastPage}</span>
                </button>
            </li>`;
    } else {
        wrapper.innerHTML = `${wrapper.innerHTML}
            <li class="disabled page-next">
                <button type="button" class="page" tabindex="-1" value='${pageActive + 1}'>
                    <span class="icon-single-chevron"></span>
                    <span class="visually-hidden">${state.buttonTooltips.nextPage}</span>
                </button>
            </li>
            <li class="disabled page-last">
                <button type="button" class="page" tabindex="-1" value='${pages}'>
                    <span class="icon-double-chevron"></span>
                    <span class="visually-hidden">${state.buttonTooltips.lastPage}</span>
                </button>
            </li>`;
    }
}

function buildItems() {
    const item = document.getElementById('list-card-component');
    const resultsMessageWrap = document.getElementById('global-search-info');
    const awards = document.querySelector('.awards-card-component');
    const grid = document.querySelector('.generic-grid-component');
    const search = document.querySelector('.global-search--results');

    let data = pagination(state.querySet, state.page, state.rows, state.total);
    let ITEMS = data.querySet;
    for (let i = 0; i < ITEMS.length; i++) {
        if (awards) {
            const cardItem = document.createElement('div');
            cardItem.setAttribute('class', 'card-item');
            item.appendChild(cardItem);

            const cardImage = document.createElement('div');
            cardImage.setAttribute('class', 'card-header card-image--center');

            const img = document.createElement('img');
            img.setAttribute('class', 'img--responsive');

            if (ITEMS[i].imageUrl) {
                img.src = ITEMS[i].imageUrl;
                cardItem.appendChild(cardImage);
                cardImage.appendChild(img);
            }

            const cardInfo = document.createElement('div');
            cardInfo.setAttribute('class', 'card-info');
            cardItem.appendChild(cardInfo);

            const cardInfoTitle = document.createElement('h3');
            cardInfoTitle.textContent = ITEMS[i].title;
            cardInfo.appendChild(cardInfoTitle);

            const cardInfoDate = document.createElement('div');
            cardInfoDate.setAttribute('class', 'date');
            cardInfoDate.textContent = ITEMS[i].date;
            cardInfo.appendChild(cardInfoDate);

            const cardInfoContent = document.createElement('div');
            cardInfoContent.innerHTML = ITEMS[i].description;
            cardInfo.appendChild(cardInfoContent);

            //CTA
            const cta = document.createElement('a');
            cta.setAttribute('class', 'button button--link');

            if (ITEMS[i].cta) {
                cta.textContent = ITEMS[i].cta;
                cta.setAttribute('href', ITEMS[i].ctaLink);
                cardInfo.appendChild(cta);
            }
        }
        if (grid) {
            const cardItem = document.createElement('div');
            cardItem.setAttribute('class', 'card-item');
            item.appendChild(cardItem);

            const cardImage = document.createElement('div');
            cardImage.setAttribute('class', 'card-header card-image--center');

            const img = document.createElement('img');
            img.setAttribute('class', 'img--responsive');

            if (ITEMS[i].imageUrl) {
                img.src = ITEMS[i].imageUrl; //'https://appsvc-uks-dev-bg-sc-sng-01.azurewebsites.net/' for testing, cocat to the img URL
                cardItem.appendChild(cardImage);
                cardImage.appendChild(img);
            }

            const cardInfo = document.createElement('div');
            cardInfo.setAttribute('class', 'card-info');
            cardItem.appendChild(cardInfo);

            const cardInfoTitle = document.createElement('h3');
            cardInfoTitle.textContent = ITEMS[i].title;
            cardInfo.appendChild(cardInfoTitle);

            const cardInfoDate = document.createElement('div');
            cardInfoDate.setAttribute('class', 'date');
            cardInfoDate.textContent = ITEMS[i].date;
            cardInfo.appendChild(cardInfoDate);

            const cardInfoContent = document.createElement('p');
            cardInfoDate.setAttribute('class', 'date');
            cardInfoContent.innerHTML = ITEMS[i].description;
            cardInfo.appendChild(cardInfoContent);

            //CTA
            const cta = document.createElement('a');
            cta.setAttribute('class', 'button button--link');

            if (ITEMS[i].link) {
                cta.textContent = ITEMS[i].linkText;
                cta.setAttribute('href', ITEMS[i].link);
                cta.setAttribute('title', ITEMS[i].tooltip);
                cardInfo.appendChild(cta);
            }
        }
        if (search) {
            let keywordInput = document.getElementById('global-search-input');
            let ctaValue = state.cta;
            let searchResultItem = `<section class="global-search--item" tabindex="0">
                                <header>
                                  <h2>${ITEMS[i].title}</h2>
                                  <div class="global-search--relevance" title="${ITEMS[i].relevanceText}">
                                    <span style="width: ${ITEMS[i].relevanceValue}"></span>
                                  </div>
                                </header>
                                <article>
                                  <p>${ITEMS[i].description}</p>
                                  <a href="${ITEMS[i].url}" title="Read more about ${ITEMS[i].title}" class="button button--link">${ctaValue}</a>
                                </article>
                              </section>`;

            //buildSearchMessages();
            item.innerHTML += searchResultItem;
        }
    }
    if (data.pages > 1) {
        pageButtons(data.pages);
    } else {
        return false;
    }
}

function buildSearchMessages() {
    const resultsMessageWrap = document.getElementById('global-search-info');
    let mathchMsg = state.match;
    let nomathchMsg = state.nomatch;
    let emptyMsg = state.empty;

    if (state.matches > 0) {
        resultsMessageWrap.innerHTML = mathchMsg;
    }
    if (state.matches === 0) {
        resultsMessageWrap.innerHTML = nomathchMsg;
    }
    if (state.matches === 0 && state.keyword === '') {
        resultsMessageWrap.innerHTML = emptyMsg;
    }
}

async function showAwardsItems(page) {
    try {
        const awards = document.querySelector('.awards-card-component');
        const wrapper = document.getElementById('pagination-wrapper');
        let currentPage = parseInt(page);
        let itemSet = pageValue;
        // read our JSON
        listContainer.appendChild(loaderWrap);
        let response = await fetch(`${APIPrefix.get()}/search_api/awards/awards?year=0&page=${currentPage}&noOfItemsPerPage=${itemSet}`);
        if (response.status === 200) {
            let jsonResponse = await response.json();
            listContainer.removeChild(loaderWrap);
            state.rows = itemSet;
            state.page = jsonResponse.data.selectedPage;
            state.total = jsonResponse.data.totalNoOfItems;
            state.querySet = jsonResponse.data.awards;
            state.buttonTooltips = jsonResponse.data.tooltips;            
            while (awards.firstChild) awards.removeChild(awards.firstChild);
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
            buildItems();
            adjustListCardComponentHeight();
        } else {
            throw new Error(response.status);
        }
    } catch (error) {
        listContainer.appendChild(errorWrap);
        listContainer.removeChild(loaderWrap);
    }
}
async function showGridItems(page) {
    try {
        const gridItems = document.querySelector('.generic-grid-component');
        const wrapper = document.getElementById('pagination-wrapper');
        let currentPage = parseInt(page);
        let itemSet;
        let gUID = gridUid;

        if (pageValueTemp !== '') {
            itemSet = pageValueTemp;
        } else {
            itemSet = 9;
        }

        listContainer.appendChild(loaderWrap);

        let response = await fetch(
            `${APIPrefix.get()}/search_api/genericpagegrid/getgrid?page=${currentPage}&noOfItemsPerPage=${itemSet}&parentId=${gUID}`
        );

        if (response.status === 200) {
            let jsonResponse = await response.json();
            listContainer.removeChild(loaderWrap);

            state.rows = itemSet;
            state.page = jsonResponse.data.selectedPage;
            state.total = jsonResponse.data.totalNoOfItems;
            state.querySet = jsonResponse.data.gridItems;
            state.buttonTooltips = jsonResponse.data.tooltips;

            while (gridItems.firstChild) gridItems.removeChild(gridItems.firstChild);
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);

            buildItems();
            setTimeout(function() {
                adjustListCardComponentHeight();
            }, 500);
        } else {
            throw new Error(response.status);
        }
    } catch (error) {
        listContainer.removeChild(loaderWrap);
        listContainer.appendChild(errorWrap);
    }
}

async function showSearchItems(page, urlkeyword) {
    try {
        const searchItems = document.querySelector('.global-search--results');
        const wrapper = document.getElementById('pagination-wrapper');
        const SEARCH_TERM = document.getElementById('global-search-input');
        let keyword;
        let currentPage = parseInt(page);
        let itemSet = pageValueTemp;

        listContainer.appendChild(loaderWrap);

        if (urlkeyword !== undefined && urlkeyword !== null) {
            keyword = urlkeyword;
        } else {
            keyword = document.getElementById('global-search-input').value;
        }

        let response = await fetch(`${APIPrefix.get()}/search_api/globalsearch/search?querystring=${keyword}&page=${currentPage}`);

        if (response.status === 200) {
            let jsonResponse = await response.json();
            listContainer.removeChild(loaderWrap);

            state.rows = itemSet;
            state.page = jsonResponse.data.selectedPage;
            state.total = jsonResponse.data.totalNoOfItems;
            state.querySet = jsonResponse.data.items;

            state.match = jsonResponse.data.searchResultsMatches;
            state.nomatch = jsonResponse.data.searchResultsNoMatches;
            state.empty = jsonResponse.data.searchResultsEmpty;

            state.matches = jsonResponse.data.totalNoOfItems;
            state.keyword = jsonResponse.data.keyword;
            state.cta = jsonResponse.data.searchResultsCta;

            state.buttonTooltips = jsonResponse.data.tooltips;

            while (searchItems.firstChild) searchItems.removeChild(gridItems.firstChild);
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);

            SEARCH_TERM.value = state.keyword;

            buildItems();
            buildSearchMessages();
            adjustListCardComponentHeight();
        } else {
            throw new Error(response.status);
        }
    } catch (error) {
        listContainer.removeChild(loaderWrap);
        listContainer.appendChild(errorWrap);
    }
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

if (awards) {
    if (listContainer) {
        showAwardsItems(1);
    }
}

if (grid) {
    if (listContainer) {
        showGridItems(1);
    }
}

if (search) {
    if (listContainer) {
        let urlkeyword = getParameterByName('keyword');
        if (urlkeyword !== undefined && urlkeyword !== null) {
            showSearchItems(1, urlkeyword);
        } else {
            showSearchItems(1);
        }
    }
}

if (nonNewsPaginatedComponent) {
    //Pagination handling page calls
    document.addEventListener('click', function(e) {
        let page = document.querySelectorAll('.page');
        let item = document.getElementById('list-card-component');
        console.log('Click event in pagination.js');
        console.log(item);
        page.forEach(function(page) {
            if (e.target === page || e.target.parentNode === page) {
                let currentPage = page.value;
                state.page = Number(page.value);

                while (item.firstChild) item.removeChild(item.firstChild);
                if (
                    document.querySelector('.awards-card-component') ||
                    document.querySelector('.generic-grid-component') ||
                    document.querySelector('.global-search--results') // ||
                ) {
                    if (document.querySelector('.awards-card-component')) {
                        if (document.getElementById('pagination-wrapper').classList.contains('awards-filtered')) {
                            //Create another if for news ?
                            showFilteredAwardsItems(currentPage);
                        } else {
                            showAwardsItems(currentPage);
                        }
                    }
                    if (document.querySelector('.generic-grid-component')) {
                        showGridItems(currentPage);
                    }
                    if (document.querySelector('.global-search--results')) {
                        showSearchItems(currentPage);
                    }
                }

            }
        });
    });

    //Enter now working on disabled items .. i mean special items !
    document.addEventListener('keypress', function(e) {
        console.log('Check for pagination keypress');
        let page = document.querySelectorAll('.page');
        page.forEach(function(page) {
            if (
                (e.target === page || e.target.parentNode === page) &&
                e.key === 'Enter' &&
                e.target.parentNode.classList.contains('disabled')
            ) {
                e.preventDefault();
            }
        });
    });
}

function adjustListCardComponentHeight() {
    let content = document.getElementById('list-card-component');
    content.style.minHeight = `${Math.min(content.scrollHeight, window.innerHeight)}px`;
    navUtils.scrollToTop();
}

//Filter Awards
if (filterWrap) {
    let filter = filterWrap.querySelector('.form-field');
    filter.addEventListener('change', filterOnChange);
}

//Filter Global Search
if (filterSearchWrap) {
    let filter = filterSearchWrap.querySelector('.form-field');
    filter.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            let item = document.getElementById('list-card-component');
            let wrapper = document.getElementById('pagination-wrapper');

            while (item.firstChild) item.removeChild(item.firstChild);
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);

            window.history.replaceState(
                'object or string',
                'Title',
                '/' + window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split('?')[0]
            );
            showSearchItems(1);
        } else {
            return false;
        }
    });

    filterSearchWrap.addEventListener('submit', function() {
        event.preventDefault();
    });
}

// Awards filter on change handler
async function filterOnChange(e) {
    // get the selected value :
    let selectedValue = e.target[e.target.selectedIndex].value;
    let filteredItems = [];
    let itemSet = pageValue;
    let item = document.getElementById('list-card-component');
    let wrapper = document.getElementById('pagination-wrapper');
    while (item.firstChild) item.removeChild(item.firstChild);
    while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);

    if (selectedValue != 0) {
        try {
            listContainer.appendChild(loaderWrap);
            let response = await fetch(`${APIPrefix.get()}/search_api/awards/awards?year=${selectedValue}&page=1&noOfItemsPerPage=${itemSet}`); //?year=2016&page1

            if (response.status === 200) {
                let jsonResponse = await response.json();
                listContainer.removeChild(loaderWrap);
                wrapper.classList.add('awards-filtered');
                let yearsData = jsonResponse.data.awards;

                for (let i = 0; i < yearsData.length; i++) {
                    filteredItems.push(yearsData[i]);
                }

                if (yearsData.length > 0) {
                    state.page = 1;
                    state.total = jsonResponse.data.totalNoOfItems;
                    state.querySet = filteredItems;
                    state.buttonTooltips = jsonResponse.data.tooltips; 
                    buildItems();
                    adjustListCardComponentHeight();
                } else {
                    listContainer.appendChild(yearsNoDataWrap);
                    adjustListCardComponentHeight();
                }
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            listContainer.removeChild(loaderWrap);
            listContainer.appendChild(errorWrap);
            adjustListCardComponentHeight();
        }
    } else {
        try {
            listContainer.appendChild(loaderWrap);
            let response = await fetch(`${APIPrefix.get()}/search_api/awards/awards?year=0&page=1&noOfItemsPerPage=${itemSet}`); //?year=2016&page1

            if (response.status === 200) {
                let jsonResponse = await response.json();
                listContainer.removeChild(loaderWrap);

                wrapper.classList.remove('awards-filtered');
                state.page = 1;
                state.total = jsonResponse.data.totalNoOfItems;
                state.querySet = jsonResponse.data.awards;
                state.buttonTooltips = jsonResponse.data.tooltips; 
                buildItems();
                adjustListCardComponentHeight();
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            listContainer.removeChild(loaderWrap);
            listContainer.appendChild(errorWrap);
            adjustListCardComponentHeight();
        }
    }
}

async function showFilteredAwardsItems(page) {
    try {
        const awards = document.querySelector('.awards-card-component');
        const wrapper = document.getElementById('pagination-wrapper');

        let currentPage = parseInt(page);
        let currentyear = filter.options[filter.selectedIndex].value;
        let itemSet = pageValue;

        listContainer.appendChild(loaderWrap);
        let response = await fetch(`${APIPrefix.get()}/search_api/awards/awards?year=${currentyear}&page=${currentPage}&noOfItemsPerPage=${itemSet}`);

        if (response.status === 200) {
            let jsonResponse = await response.json();
            listContainer.removeChild(loaderWrap);

            state.rows = pageValue;
            state.page = jsonResponse.data.selectedPage;
            state.total = jsonResponse.data.totalNoOfItems;
            state.querySet = jsonResponse.data.awards;
            state.buttonTooltips = jsonResponse.data.tooltips;

            while (awards.firstChild) awards.removeChild(awards.firstChild);
            while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
            buildItems();
            adjustListCardComponentHeight();
        } else {
            throw new Error(response.status);
        }
    } catch (error) {
        listContainer.removeChild(loaderWrap);
        listContainer.appendChild(errorWrap);
        adjustListCardComponentHeight();
    }
}